export default __webpack_public_path__ + "static/media/Emotional10.279567ba.png";